import React from 'react'
import { useState } from 'react';

function ToDoItem({todo, deleteTodo, toggleComplete, editTodo}) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(todo.text);

  function handleEdit() {
    editTodo(todo.id, text);
    setEditing(false);
  }
  return (
    <div className={`TodoItem ${todo.completed ? "completed" : ""}`}>
      <input
        type="checkbox"
        checked={todo.completed}
        onChange={() => toggleComplete(todo.id)}
      />

      {editing ? (
        <>
          <input
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <button onClick={handleEdit}>Save</button>
        </>
      ) : (
        <span
          style={{
            textDecoration: todo.completed ? "line-through" : "none"
          }}
        >
          {todo.text}
        </span>
      )}

      <button onClick={() => setEditing(!editing)}>
        Edit
      </button>

      <button onClick={() => deleteTodo(todo.id)}>
        Delete
      </button>

    </div>
  )
}

export default ToDoItem
